import { gql } from '@grandvisionhq/graphql';

const createReturnFailuresFragment = gql`
  fragment CreateReturnFailuresFragment on CreateReturnFailure {
    ... on Failure {
      message
    }
  }
`;

export { createReturnFailuresFragment };
//# sourceMappingURL=create-return-failures.js.map
